import { ReactNode, useState } from 'react';
import Popover, { PopoverProps } from '@mui/material/Popover';
import BaseButton from './BaseButton';
import { Box } from '@mui/material';
import BaseIconButton from './BaseIconButton';

interface PopoverMenuProps extends Omit<PopoverProps, 'open'> {
    title: string;
    icon: ReactNode;
    isIconButton?: boolean;
    children: ReactNode;
}

export default function PopoverMenu({ title, icon, isIconButton = false, children, ...props }: PopoverMenuProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    return (
        <>
            {!isIconButton ? (
                <BaseButton startIcon={icon} onClick={handleClick}>
                    {title}
                </BaseButton>
            ) : (
                <BaseIconButton onClick={handleClick}>{icon}</BaseIconButton>
            )}

            <Popover
                {...props}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                disableScrollLock
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ pt: 1, pr: 1.5 }}>{children}</Box>
            </Popover>
        </>
    );
}
